module.exports = __webpack_public_path__ + "static/media/security-iovation-white.6c5089ee.svg";